module.exports = __webpack_public_path__ + "static/media/construction.4bc2d788.gif";